import { useSelector } from 'react-redux';

export const usePermissions = (resource) => {
  const permissions = useSelector((state) => state.permission.myPermissions);
  const isLoading = useSelector((state) => state.permission.myPermissionsLoading);
 
  const perm = permissions.find((p) => p.resource === resource) || {};

  return {
    canCreate: perm.can_create ?? false,
    canRead:   perm.can_read   ?? false,
    canUpdate: perm.can_update ?? false,
    canDelete: perm.can_delete ?? false,
    canImport: perm.can_import ?? false,
    canExport: perm.can_export ?? false,
    isLoading,
  };
};